import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgCave = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		id="cave_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>{`.prestation_cls_fill{fill:${color}`}</style>
		</defs>
		<path
			className="prestation_cls_fill"
			d="M323.59 276.2v-106c0-61.2-49.79-110.99-110.99-110.99S101.61 109 101.61 170.2v195.79h221.98v-52.37H291.8v-42.4h-31.81v-42.4H228.2v-42.4H127.8v9.97h90.43v32.43H127.8v9.97h122.22v32.43H127.8v9.97h154.03v32.43H127.8v9.97h185.82v32.43H111.58V170.2c0-55.7 45.32-101.02 101.02-101.02S313.62 114.5 313.62 170.2v106h9.97Z"
		/>
		<path
			className="prestation_cls_fill"
			d="M244.4 175.18h36.77v-4.79c0-.07.01-.13.01-.19v-33.59h-9.97v21.23l-53.7-55.67-7.18 6.92 54.12 56.11h-20.06v9.97Z"
		/>
	</svg>
)
export default SvgCave
